import { createResourceId } from 'src/utils/create-resource-id';
import { decode, JWT_EXPIRES_IN, JWT_SECRET, sign } from 'src/utils/jwt';
import { wait } from 'src/utils/wait';
import { users } from './data';
import httpServices, { AppContext } from 'src/services/httpServices';
import { login } from 'src/services/authServices';
import { jwtDecode } from 'jwt-decode';
import { DataHelper } from 'src/services/dataHelper';

const STORAGE_KEY = 'users';

// NOTE: We use sessionStorage since memory storage is lost after page reload.
//  This should be replaced with a server call that returns DB persisted data.

const getPersistedUsers = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY);

    if (!data) {
      return [];
    }

    return JSON.parse(data);
  } catch (err) {
    console.error(err);
    return [];
  }
};

const persistUser = (user) => {
  try {
    const users = getPersistedUsers();
    const data = JSON.stringify([...users, user]);
    sessionStorage.setItem(STORAGE_KEY, data);
  } catch (err) {
    console.error(err);
  }
};

class AuthApi {
  async signIn(request) {
    const { email, password } = request;
    // alert(JSON.stringify( request))

    // login(email, password);

    await wait(500);


    return new Promise(async (resolve, reject) => {
     // alert(resolve)
      try {
        // Merge static users (data file) with persisted users (browser storage)
        const mergedUsers = [
          ...users,
          ...getPersistedUsers()
        ];

        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        let ID = (decoded.userId);
        //alert(JSON.stringify(decoded))


        const userall = AppContext.userDetails;


        if (userall === undefined || userall === "") {

          reject(new Error('Please check your email and password'));
          return;

        } else {


          // Create the access token
          const accessToken = sign({ userId: ID }, JWT_SECRET, { expiresIn: JWT_EXPIRES_IN });
         // alert(JSON.stringify(accessToken))
          resolve({ accessToken });
        }

        AppContext.userDetails = "";
      } catch (err) {
        console.error('[Auth Api]: ', err);
        // reject(new Error('Internal server error'));
      }
    });
  }

  async signUp(request) {
    const { email, name, password } = request;

    await wait(1000);

    return new Promise((resolve, reject) => {
      try {
        // Merge static users (data file) with persisted users (browser storage)
        const mergedUsers = [
          ...users,
          ...getPersistedUsers()
        ];

        // Check if a user already exists
        let user = mergedUsers.find((user) => user.email === email);

        if (user) {
          reject(new Error('User already exists'));
          return;
        }

        user = {
          id: createResourceId(),
          avatar: undefined,
          email,
          name,
          password,
          plan: 'Standard'
        };

        persistUser(user);

        const accessToken = sign({ userId: user.id }, JWT_SECRET, { expiresIn: JWT_EXPIRES_IN });

        resolve({ accessToken });
      } catch (err) {
        console.error('[Auth Api]: ', err);
        reject(new Error('Internal server error'));
      }
    });
  }

  me(request) {

    // alert( JSON.stringify(  request));

    const { accessToken } = request;

    return new Promise((resolve, reject) => {
      try {
        // Decode access token
        const decodedToken = decode(accessToken);
  
        // Merge static users (data file) with persisted users (browser storage)
        const mergedUsers = [
          ...users,
          ...getPersistedUsers()
        ];

        // Find the user
        const { userId } = decodedToken;
       // const user = mergedUsers.find((user) => user.id === userId);
       // alert(JSON.stringify( decodedToken))
        // if (!user) {
        //   reject(new Error('Invalid authorization token'));
        //   return;
        // }

        resolve({
          id: userId,
          // avatar: user.avatar,
           email: "",
          // name: user.name,
          // plan: user.plan
        });
      } catch (err) {
        console.error('[Auth Api]: ', err);
        reject(new Error(err));
      }
    });
  }
}

export const authApi = new AuthApi();
